export default {
  step2: {
    id: 'new_payment_result_success_step2',
    defaultMessage:
      'Remember to watch your spam and within a few days, we will ask you for news, just to see if you are satisfied.',
  },
}
